import { useState } from 'react';
import { ArticleRequest } from '../../api/queries';
import { Outlet } from 'react-router-dom';

export const ContentSystemPageLayout = () => {
  const [guide, setGuide] = useState<ArticleRequest>({
    title: '',
    coverImageUrl: '',
    coverImageAlt: '',
    jsonContent: { type: 'doc', content: [] },
    isGlobalGuide: false,
    labels: [],
    isDraft: true,
    updatedAt: new Date(),
    draftId: 0,
  });

  return (
    <div style={{ display: 'grid', gap: '2rem' }}>
      <Outlet context={{ guide, setGuide }} />
    </div>
  );
};
